// NewUpcomingProjects.jsx

import React, { useEffect, useState } from "react";
import "./upcomingprojects.css";

import Slider from "react-slick";

import HomeService from "../../../Services/HomeService";

import { toast } from "react-toastify";

import ReelsPlayer from ".././ReelsPlayer/ReelsPlayer";

import { FaPlay } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { HiOutlineLocationMarker } from "react-icons/hi";

const NewUpcomingProjects = () => {

  const [reels, setReels] = useState([]);

  const [selectedReel, setSelectedReel] = useState(null);

  const [isReelsPlayerOpen, setIsReelsPlayerOpen] =
    useState(false);

  /* =========================
     FETCH REELS
  ========================= */

  const fetchReels = async () => {

    try {

      const res = await HomeService.getReels();

      console.log("reels", res);

      if (res?.status) {
        setReels(res?.data);
      } else {
        toast.error(res?.message);
      }

    } catch (error) {

      console.log(error);

      toast.error(error?.message);

    }
  };

  useEffect(() => {
    fetchReels();
  }, []);

  /* =========================
     OPEN PLAYER
  ========================= */

  const handleReelClick = (reel) => {

    setSelectedReel(reel);

    setIsReelsPlayerOpen(true);
  };

  /* =========================
     CLOSE PLAYER
  ========================= */

  const handleCloseReelsPlayer = () => {

    setIsReelsPlayerOpen(false);

    setSelectedReel(null);
  };

  /* =========================
     SLIDER
  ========================= */

  const settings = {
    dots: false,
    infinite: true,
    speed: 700,
    autoplay: true,
    autoplaySpeed: 2500,
    pauseOnHover: true,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,

    responsive: [

      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
        },
      },

      {
        breakpoint: 980,
        settings: {
          slidesToShow: 2,
        },
      },

      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1,
        },
      },

    ],
  };

  return (
    <>

      <section className="upcomingx-main-section">

        {/* TOP */}

        <div className="elitefame-top-wrapper">

          <span className="upcomingx-subtitle">
            Future Developments
          </span>

          <h2 className="insightx-title_n">
            Our Upcoming Projects
          </h2>

        </div>

        {/* <div className="upcomingx-top-wrapper">

          <div className="elitefame-top-wrapper">

            <span className="upcomingx-subtitle">
              Future Developments
            </span>

            <h2 className="insightx-title_n">
              Our Upcoming Projects
            </h2>

          </div>

          <button className="upcomingx-view-btn">
            Explore More
          </button>

        </div> */}

        {/* SLIDER */}

        <div className="upcomingx-slider-wrapper">

          <Slider {...settings}>

            {reels?.map((reel, i) => (

              <div key={i}>

                <div
                  className="upcomingx-card"
                  onClick={() =>
                    handleReelClick(reel)
                  }
                >

                  {/* IMAGE */}

                  <div className="upcomingx-image-wrapper">
                    <img
                      src={
                        reel?.thumbnail ||
                        "https://static.vecteezy.com/system/resources/thumbnails/040/813/403/small/building-design-render-photo.jpg"
                      }
                      alt=""
                    />

                    <div className="upcomingx-overlay"></div>

                    {/* LOCATION */}

                    <div className="upcomingx-location">

                      <HiOutlineLocationMarker />

                      <span>
                        Premium Project
                      </span>

                    </div>

                    {/* PLAY BUTTON */}

                    <div className="upcomingx-play-btn">

                      <FaPlay />

                    </div>

                  </div>

                  {/* CONTENT */}

                  <div className="upcomingx-content">

                    <h3>
                      Luxury Living Project
                    </h3>

                    <p>
                      Discover premium upcoming
                      residential developments with
                      modern amenities & futuristic
                      designs.
                    </p>

                    <div className="upcomingx-bottom">

                      <div>

                        <h4>
                          2026
                        </h4>

                        <span>
                          Launch Year
                        </span>

                      </div>

                      <button className="upcomingx-watch-btn">
                        Watch Reel
                      </button>

                    </div>

                  </div>

                </div>

              </div>

            ))}

          </Slider>

        </div>

      </section>

      {/* =========================
          MODAL
      ========================= */}

      {isReelsPlayerOpen &&
        selectedReel && (

          <div
            className="upcomingx-modal-overlay"
            onClick={
              handleCloseReelsPlayer
            }
          >

            <div
              className="upcomingx-modal-content"
              onClick={(e) =>
                e.stopPropagation()
              }
            >

              {/* CLOSE */}

              <button
                className="upcomingx-close-btn"
                onClick={
                  handleCloseReelsPlayer
                }
              >

                <IoClose />

              </button>

              {/* VIDEO */}

              <ReelsPlayer
                videoUrl={
                  selectedReel?.video
                }
                autoPlay={true}
                muted={false}
                controls={true}
                loop={true}
              />

            </div>

          </div>

        )}

    </>
  );
};

export default NewUpcomingProjects;